import React, { useEffect } from 'react';
import {
    Block,
    Heading3,
    SpaceBetweenDiv,
    SearchInput,
    FlexDiv,
} from '@awarego-ui/components';
import { observer } from 'mobx-react';
import EmployeesCheckboxTable from './components/EmployeesCheckboxTable';
import ScoreFilter from './components/scoreFilter';
import { useStores } from '../../hooks/use-stores';
import { useAssessmentType } from '../assessment/useAssessmentType';

function EmployeesList({
    companyId,
    assessmentId,
    threatArea = '',
    assessmentUsersStore,
    product,
    canRemind,
    rowMenuVariant = 'assessment',
}) {
    const { userNamePlural, userNamePluralTitle } = useAssessmentType();

    const {
        usersTotal,
        userListSearchValue,
        order,
        pageIndex,
        pageSize,
        loadingUsersList,
        minScore,
        maxScore,
        scoreName,
    } = assessmentUsersStore;

    const { authStore } = useStores();
    const { anonymousTracking } = authStore;

    useEffect(() => {
        assessmentUsersStore.setThreatArea(
            threatArea !== '' ? threatArea : null
        );
        if (!anonymousTracking) {
            assessmentUsersStore.loadUsers(companyId, assessmentId);
        }
    }, [
        assessmentId,
        companyId,
        threatArea,
        pageIndex,
        pageSize,
        order,
        minScore,
        maxScore,
        assessmentUsersStore,
        anonymousTracking,
    ]);

    useEffect(() => {
        if (!anonymousTracking) {
            assessmentUsersStore.debouncedLoadUsers(
                companyId,
                assessmentId
            );
        }
    }, [
        assessmentUsersStore,
        assessmentId,
        companyId,
        userListSearchValue,
        anonymousTracking,
    ]);

    const onScoreFilterApply = (minScore, maxScore) => {
        assessmentUsersStore.setScores(minScore, maxScore);
    };

    return (
        <Block gap={24}>
            <SpaceBetweenDiv>
                <Heading3>
                    {userNamePluralTitle} {!loadingUsersList && `(${usersTotal})`}
                </Heading3>
                {!anonymousTracking && (
                    <FlexDiv gap={16} alignCenter $noWrap>
                        <ScoreFilter
                            scoreName={scoreName}
                            initialMinScore={minScore}
                            initialMaxScore={maxScore}
                            onScoreFilterApply={onScoreFilterApply}
                        />
                        {product._rawData.definition.authentication !== 'no-email' && (
                            <SearchInput
                                searchValue={userListSearchValue}
                                placeholder={`Search ${userNamePlural}`}
                                onChange={(e) =>
                                    assessmentUsersStore.setUserListSearchValue(
                                        e.target.value
                                    )
                                }
                                onClear={() =>
                                    assessmentUsersStore.setUserListSearchValue(
                                        ''
                                    )
                                }
                            />
                        )
                        }
                    </FlexDiv>
                )}
            </SpaceBetweenDiv>
            <EmployeesCheckboxTable
                companyId={companyId}
                productId={assessmentId}
                product={product}
                store={assessmentUsersStore}
                isEmployeesList
                canRemind={canRemind}
                anonymousTracking={anonymousTracking}
                rowMenuVariant={rowMenuVariant}
            />
        </Block>
    );
}

export default observer(EmployeesList);
